import { render, staticRenderFns } from "./RAPluginCarousel.vue?vue&type=template&id=4c56816c&"
import script from "./RAPluginCarousel.vue?vue&type=script&lang=js&"
export * from "./RAPluginCarousel.vue?vue&type=script&lang=js&"
import style0 from "./RAPluginCarousel.vue?vue&type=style&index=0&id=4c56816c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports